import { render, staticRenderFns } from "./ImportCommonSalary.vue?vue&type=template&id=fc7bb272&scoped=true"
import script from "./ImportCommonSalary.vue?vue&type=script&lang=js"
export * from "./ImportCommonSalary.vue?vue&type=script&lang=js"
import style0 from "./ImportCommonSalary.vue?vue&type=style&index=0&id=fc7bb272&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7bb272",
  null
  
)

export default component.exports